// Actions for Skills Context
export const SET_GOAL = 'SET_GOAL';
export const SET_CURRENT_JOB_TITLE = 'SET_CURRENT_JOB_TITLE';
export const ADD_CAREER_INTEREST = 'ADD_CAREER_INTEREST';
export const REMOVE_CAREER_INTEREST = 'REMOVE_CAREER_INTEREST';
export const CLEAR_ALL_CAREER_INTERESTS = 'CLEAR_ALL_CAREER_INTERESTS';
export const ADD_TO_EXPANDED_LIST = 'ADD_TO_EXPANDED_LIST';
export const REMOVE_FROM_EXPANDED_LIST = 'REMOVE_FROM_EXPANDED_LIST';
export const SET_EXPANDED_LIST = 'SET_EXPANDED_LIST';
